export const SELECTED_BRANCH_STORAGE_KEY = 'selectedBranchId';
export const SELECTED_BRANCH_CHANGE_EVENT = 'selected-branch-change';

const canUseWindow = () => typeof window !== 'undefined';

export const getSelectedBranchId = () => {
  if (!canUseWindow()) return '';
  return String(window.localStorage.getItem(SELECTED_BRANCH_STORAGE_KEY) || '');
};

export const persistSelectedBranchId = (branchId) => {
  if (!canUseWindow()) return '';
  const nextBranchId = String(branchId || '').trim();
  if (nextBranchId) {
    window.localStorage.setItem(SELECTED_BRANCH_STORAGE_KEY, nextBranchId);
  } else {
    window.localStorage.removeItem(SELECTED_BRANCH_STORAGE_KEY);
  }
  window.dispatchEvent(new CustomEvent(SELECTED_BRANCH_CHANGE_EVENT, {
    detail: { branchId: nextBranchId },
  }));
  return nextBranchId;
};

export const subscribeSelectedBranch = (handler) => {
  if (!canUseWindow() || typeof handler !== 'function') return () => {};

  const handleChange = (event) => {
    handler(String(event?.detail?.branchId || ''));
  };
  const handleStorage = (event) => {
    if (event.key !== SELECTED_BRANCH_STORAGE_KEY) return;
    handler(String(event.newValue || ''));
  };

  window.addEventListener(SELECTED_BRANCH_CHANGE_EVENT, handleChange);
  window.addEventListener('storage', handleStorage);
  return () => {
    window.removeEventListener(SELECTED_BRANCH_CHANGE_EVENT, handleChange);
    window.removeEventListener('storage', handleStorage);
  };
};
